import SetData from "@/vuex/SetData";

import DAOSet from '@/assets/DAO/Set';
import DAOItemPrice from '@/assets/DAO/Item/Price';
import DAOItemDescription from "@/assets/DAO/Item/Description";
import DAOItemAdditionalItems from "@/assets/DAO/Item/AdditionalItems";
import DAOWishlist from '@/../public/js/DAO/Wishlist.js'

import Url from "@/assets/Url";
import MetaData from "@/assets/MetaData";
import Logger from "@/assets/Helper/Logger";


SetData.watch(() => SetData.getters.getItemStr, itemStr => {
    let items = itemStr.split("_");

    if (items.length > 0 && items[0] !== "") {
        for (let itemsKey in items) {
            if (Object.prototype.hasOwnProperty.call(items, itemsKey)) {
                DAOItemPrice.getPrice(items[itemsKey]);
            }
        }

        DAOItemDescription.getDescription(items);
        DAOItemAdditionalItems.getItems(items);
    } else {
        MetaData.set();
    }

    if (SetData.getters.getWishlistItemId === null || SetData.getters.getWishlistItemId === false) {
        let wishlistData = SetData.getters.getWishlistItemData;
        DAOWishlist.getItemId('configure', wishlistData).then(wishlistItemId => {
            if (wishlistItemId === false && wishlistData.items.length > 0) {
                DAOWishlist.dropLastIfLimitReached('configure');
                DAOWishlist.add('configure', wishlistData).then(wishlistItemId => SetData.dispatch('setWishListItemId', wishlistItemId));
            } else {
                SetData.dispatch('setWishListItemId', wishlistItemId).catch((error) => {
                    Logger.error(error);
                });
            }
        });
    } else {
        let wishlistData = SetData.getters.getWishlistItemData;
        let wishlistId = SetData.getters.getWishlistItemId;
        if (typeof wishlistId == 'number' &&
            wishlistId > 0 &&
            typeof wishlistData.items == 'object' &&
            wishlistData.items.length > 0
        ) {
            DAOWishlist.update('configure', wishlistId, wishlistData).catch((error) => {
                Logger.error(error);
            });
        }
    }

    if (history && history.state && history.state.ispopstate) {
        // do nothing
    } else {
        Url.setItemnumbers(items);
    }
});

SetData.watch(() => SetData.getters.getSetId, setId => {
    if (setId !== "" && SetData.getters.getItemStr.length === 0) {
        let setParemeter = SetData.getters.getSetIdParameter;
        DAOSet.getItemnumbers(setId, true, setParemeter);
    }
});

SetData.watch(() => SetData.getters.getTotalPrice, () => {
    let wishListId = SetData.getters.getWishlistItemId;

    if (typeof wishListId === 'number')
        DAOWishlist.update('configure', wishListId, SetData.getters.getWishlistItemData).catch((error) => {
            Logger.error(error);
        });
});

SetData.watch(() => SetData.getters.getCurrentItemId, currentItem => {
    let node = document.getElementById('itemImage-' + currentItem);
    if (node !== null) {
        const slider = document.getElementById("image-list");
        slider.scrollTo({
          left: node.getBoundingClientRect().x + slider.scrollLeft,
          behavior: "smooth",
        });
    }
});
